// Mirrors Tailwind's default breakpoints for scripts (app.css doesn't override them).
export const screens = {
  sm: '640px',
  md: '768px',
  lg: '1024px',
  xl: '1280px',
  '2xl': '1536px',
};
